import { push } from 'react-router-redux';

export const redirectTo404 = (search, pathname) => {
  return dispatch => {
    if (pathname !== '/404') {
      dispatch(push({ pathname: `/404${search}`, state: 301 }));
    }
    return Promise.resolve();
  };
};



// WEBPACK FOOTER //
// ./app/actions/redirect-to-404.js